import { Spinner } from './styles';

export function LoadingSpinner({ size = 36, borderSize = 4 }) {
  return <Spinner size={size} borderSize={borderSize} />;
}
